module.exports = __webpack_public_path__ + "OneSignalSDKUpdaterWorker.js";